<template>
    <v-card>
        <v-form
            ref="subscriptionForm"
            v-model="isValid"
        >
            <v-card-text>
                <v-container
                    class="pb-0"
                    fluid
                >
                    <v-row class="pb-0">
                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                :rules="[requiredRule,lengthRule(50)]"
                                label="Name"
                                v-model="subscription.name"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                :rules="[requiredRule,
                      ]"
                                label="Amount"
                                min="0"
                                type="number"
                                v-model.number="subscription.amount"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                :rules="[requiredRuleNum,
                      ]"
                                label="Allowed Dependants"
                                min="0"
                                step="1"
                                type="number"
                                v-model.number="subscription.dependantsCount"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-switch
                                class="mb-0"
                                label="Is Individual"
                                v-model="subscription.isIndividual"
                            ></v-switch>
                        </v-col>
                    </v-row>
                    <v-row
                        align="end"
                        class="pt-0"
                        justify="space-between"
                        no-gutters
                    >
                        <v-btn
                            :disabled="isLoading && !isDeleting"
                            :loading="isDeleting"
                            @click="deleteEntity"
                            class="text-none"
                            color="warning darken-1"
                            text
                            v-show="subscription.id > 0"
                        >Delete</v-btn>
                        <v-btn
                            :disabled="isLoading"
                            @click="closeForm"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Close</v-btn>
                        <v-btn
                            :disabled="isLoading && !isSaving"
                            :loading="isSaving"
                            @click="saveEntity"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >{{subscription.id > 0 ? "Update" : "Add"}}</v-btn>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-form>
        <v-snackbar
            :color="notifyColor"
            :timeout="15000"
            top
            v-model="notifyShow"
        >
            {{ notifyMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    @click="notifyShow = false"
                    class="text-none"
                    icon
                    v-bind="attrs"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </v-card>
</template>

<script>
import Subscription from "../../models/Subscription.model";
export default {
    props: {
        subscriptionIn: Subscription
    },
    components: {
        //
    },
    data() {
        return {
            subscription: new Subscription().set(this.subscriptionIn),
            isValid: null,
            isLoading: null,
            isSaving: null,
            isDeleting: null,
            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,
            requiredRule: v => !!v || "required",
            requiredRuleNum: v => !!v || v === 0 || "required",
            lengthRule: limit => v =>
                !v || v.length <= limit || "exceeds " + limit + " characters"
        };
    },

    methods: {
        //emitters      ------------------------------------------------------------
        emitSavedEntity(savedSubscription) {
            this.$emit("saved", savedSubscription);
        },
        emitDeletedEntity(deletedSubscription) {
            this.$emit("deleted", deletedSubscription);
        },
        emitCloseForm() {
            this.$emit("close");
        },
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        closeForm() {
            this.notifyShow = false;
            this.emitCloseForm();
        },
        validateForm() {
            this.isValid = this.$refs.subscriptionForm.validate();
            return this.isValid;
        },
        //save      ------------------------------------------------------------
        saveEntity() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;

                this.$store
                    .dispatch(
                        "subscriptions/" +
                            (this.subscription.id == 0 ? "create" : "update"),
                        this.subscription
                    )
                    .then(
                        subscriptionWithInfo => {
                            this.notify(
                                "Subscription successfully saved.",
                                "success"
                            );
                            if (this.subscription.id == 0) {
                                this.subscription.id =
                                    subscriptionWithInfo.entity.id;
                            }
                            this.emitSavedEntity(subscriptionWithInfo);
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.saveEntityDone);
            }
        },
        saveEntityDone() {
            this.isLoading = false;
            this.isSaving = false;
        },
        //delete        ------------------------------------------------------------
        deleteEntity() {
            var isConfirmed = confirm(
                "Are you sure you want to delete this subscription?"
            );
            if (isConfirmed) {
                this.isLoading = true;
                this.isDeleting = true;
                this.$store
                    .dispatch("subscriptions/delete", this.subscription.id)
                    .then(
                        () => {
                            this.notify(
                                "Subscription successfully deleted.",
                                "success"
                            );
                            this.emitDeletedEntity(this.subscription);
                            this.closeForm();
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.deleteEntityDone);
            }
        },
        deleteEntityDone() {
            this.isLoading = false;
            this.isDeleting = false;
        }
    }
};
</script>

<style lang="stylus" scoped></style>